import getAxiosWithStrapi from './strapiFactory';

const templatesApi = {
  fetchTemplates: () =>
    getAxiosWithStrapi({
      url: '/page-templates?pagination[limit]=false&populate=icon_uri.asset',
      method: 'get',
    }),
  getTemplateByDocumentId: (documentId) =>
    getAxiosWithStrapi({
      url: `/page-templates/${documentId}?populate=icon_uri.asset`,
      method: 'get',
    }),
  updateTemplate: ({ documentId, updatedTemplate }) =>
    getAxiosWithStrapi({
      url: `/page-templates/${documentId}?populate=icon_uri.asset`,
      method: 'put',
      data: {
        data: updatedTemplate,
      },
    }),
  deleteTemplate: (documentId) =>
    getAxiosWithStrapi({
      url: `/page-templates/${documentId}?populate=icon_uri.asset`,
      method: 'delete',
    }),
};

export default templatesApi;
